window.GoogleDrive = {
	loadPrefs : function(){
		var options = {
			title	: Loc.g("Préférences Google Drive"),
			buttons	: [
				{
                    text : Loc.g("Fermer"),
                    class: 'btn btn-default',
					click : function(){MyWindow.close();
					}
				}
			],
			width: 500,
			callback : function(){GoogleSync.preparePrefsForm()}
		};
		
		var fileOpt = {action:""};
		MyWindow.load("googledrive_prefs", fileOpt, options);
	},
	
	preparePrefsForm : function(){
		var options = {success:function(data){MyWindow.awake();}, dataType:"json"};
		MyForm.prepare("gdrivePrefsForm", "googledrive_prefs&action=record", options, true);
		MyFacture.customForm(); 
		
		$('#gdrivePrefsForm :input').on('click', function(){
			$(this).closest('form').submit();
		});
	},

	connect : function() {
		MyFacture.post("googledrive_prefs&action=getToken", null,  function(data) {
			if(data != null) {
				var options = {
					resizable	: false,
					noclose		: true,
					title		: Loc.g("Connexion à Google"),
					buttons		: [
						{text : Loc.g("Valider"), click: function(){window.location = data.authUrl;}},
						{text : Loc.g("Annuler"), click: function(){MyFacture.post("googledrive_prefs&action=disconnect", null, null, "json");$(this).dialog("close");}}
					]
				};
				MyWindow.alert(Loc.g("Vous allez être redirigé vers la page d'authentification de Google.")+"<br/><br /> "+Loc.g("Acceptez l'application pour synchroniser vos documents."), options);
			}
		}, "json");
		
		$(document).keyup(function(e) {
			if (e.keyCode == 27) { 
				MyFacture.post("googledrive_prefs&action=disconnect", null, null, "json");
			}
		});
	},

	disconnect : function() {
		MyFacture.post("googledrive_prefs&action=disconnect", null, function(data) {
			GoogleDrive.loadPrefs();
		}, "json");
	},	
			
			
	sendToDrive: function(docID, type) {

		if(type == undefined){
			var type = "doc";
		}

		var datas = {
			action: "syncDoc",
			docid: docID,
                        type: type
		};

		$("#actionBtn\\[googledrive\\]").css('position', 'relative').append('<img style="position:absolute;right:5px;top:1px;" id="driveloader" src="/ressources/logged/img/common/loader.gif"/>');

		MyFacture.send("googledrive_sync", datas, function(data) {
			if (data != null && data.driveError) {
				var options = {
					dialogClass: "white",
					resizable: false,
					noclose: true,
					title: Loc.g("Synchronisation Google Drive"),
					buttons: [
						{text: Loc.g("Valider"), click: function() {
								$(this).dialog("close");
							}}
					]
				};
				MyWindow.alert(data.driveError, options);
			} else {
				MyWindow.alert(Loc.g("La demande de synchronisation a été ajouté à la file d'attente, votre document sera disponible dans quelques instants sur votre dépôt Google Drive")+".", {dialogClass : "white"});
			}
			$("#driveloader").remove();
		}, "json");
	},
	
	
	enableAutoSync : function(me){	
		var enabled = "N";
		if (me.is(':checked')){
			enabled = "Y";
		}
		
		MyFacture.post("googledrive_prefs", "action=toggleAutoSync&enabled="+enabled, function(response){});
	}
};